const crossellForm = {
  crossells: document.querySelectorAll(
    '.jsSingleCrosssell',
  ) as NodeListOf<HTMLElement>,

  init() {
    this.crossells.forEach((item) => {
      this.setListeners(item);
    });
  },

  setListeners(item: HTMLElement) {
    const select = item.querySelector(
      '.jsProdVarSelect',
    ) as HTMLSelectElement | null;
    const inputSku = item.querySelector('.jsSku') as HTMLInputElement;
    const inputThumb = item.querySelector('.jsThumb') as HTMLInputElement;
    const inputModal = item.querySelector('.jsModel') as HTMLInputElement;
    const inputQty = item.querySelector('.jsQty') as HTMLInputElement;
    const inputBtn = item.querySelector('.jsSelectBtn') as HTMLButtonElement;
    const inputPrice = item.querySelector('.jsPrice') as HTMLElement;

    select?.addEventListener('change', () => {
      const optionData = select.selectedOptions[0].dataset;
      inputSku.id = `sku${optionData.rand}`;
      inputSku.name = `sku${optionData.rand}`;
      inputSku.value = select.value;

      inputThumb.id = `thumb${optionData.rand}`;
      inputThumb.name = `thumb${optionData.rand}`;
      inputThumb.value = optionData.thumb || '';

      inputModal.id = `model${optionData.rand}`;
      inputModal.name = `model${optionData.rand}`;
      inputModal.value = optionData.model || '';

      inputQty.id = `qty${optionData.rand}`;
      inputQty.name = `qty${optionData.rand}`;
      inputQty.value = '1';

      inputBtn.setAttribute('rel', `${optionData.rand}`);
      inputBtn.title = `Add ${optionData.model} to Cart`;
      inputBtn.classList.remove('main-btn--disabled');
      inputPrice.innerText = optionData.priceText || '';
    });
  },
};

export default crossellForm;
